// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7963) return "static/chunks/7963-b218a8c9099521b7.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2112":"19f3cc5e","2664":"b56196ea","8532":"fc6dfb98","8789":"02fb1a95"}[chunkId] || chunkId) + "." + {"2112":"ab70a7c841e772ab","2664":"7dc2832a8ae7e384","5117":"7ab9a407b7a503da","5683":"9b59fd60989df848","6989":"b1a07eab53707f67","8532":"b39009526d1dc3b9","8752":"f3b70ebb29130167","8789":"8f9bd50e267ed443"}[chunkId] + ".js";
};